import BlStepperShortMv from './BlStepperShortMv.vue'

BlStepperShortMv.install = function(Vue) {
  Vue.component(BlStepperShortMv.name, BlStepperShortMv)
}

export default BlStepperShortMv
